module.exports = __webpack_public_path__ + "img/arrow_up.d90b48a9.svg";